import { useEffect } from 'react';
import { FieldRenderProps, useField } from 'react-final-form';

import { SecurityResponseMembershipOptions } from '../../../../../../../models/enums/SecurityResponseMembershipOptions';

import { IOrganizationSearch } from '../../../../../../../models/interfaces/SearchOrganization';
import { SRMembershipOrganizationDetailsFormFields } from '../SRMembershipDetailsForm/srMembershipDetailsForm.models';

export const useSRMembershipOptions = () => {
  const {
    input: { onChange: sendWelcomeEmailChange },
  }: FieldRenderProps<boolean> = useField(
    SecurityResponseMembershipOptions.SendWelcomeEmail,
  );

  const {
    input: { onChange: autoRenewalChange },
  }: FieldRenderProps<boolean> = useField(
    SecurityResponseMembershipOptions.AutoRenewal,
  );

  const {
    input: { value: selectedOrganization },
  }: FieldRenderProps<IOrganizationSearch> = useField(
    SRMembershipOrganizationDetailsFormFields.Organization,
  );

  const {
    input: { value: subscriptionType },
  }: FieldRenderProps<string> = useField(
    SRMembershipOrganizationDetailsFormFields.SubscriptionType,
  );

  useEffect(() => {
    if (!subscriptionType || !selectedOrganization) {
      sendWelcomeEmailChange(null);
      autoRenewalChange(null);
      return;
    }

    const subscriptionIndex = selectedOrganization.subscriptions.findIndex(
      (x) => x.id === subscriptionType,
    );

    if (subscriptionIndex === -1) {
      sendWelcomeEmailChange(null);
      autoRenewalChange(null);
      return;
    }

    sendWelcomeEmailChange(
      selectedOrganization.subscriptions[subscriptionIndex].sendWelcomeEmail,
    );
    autoRenewalChange(
      selectedOrganization.subscriptions[subscriptionIndex]
        .autoRenewalMemberships,
    );
  }, [
    autoRenewalChange,
    selectedOrganization,
    sendWelcomeEmailChange,
    subscriptionType,
  ]);
};
